import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/layout';
import SpinnerLoader from '../components/ui/Loader/spinner';

// Eagerly load Login — it's the landing page for unauthenticated users
import Login from '../pages/Auth/Login';

// Lazy-load all other pages — they are only downloaded when the user navigates to them
const Home = lazy(() => import('../pages/Home'));
const ContactsView = lazy(() => import('../pages/ContactsView'));
const MyProfileContainer = lazy(() => import('../pages/Profile'));
const SettingsContainer = lazy(() => import('../pages/Settings/Containers/SettingsContainer'));
const CatalogContainer = lazy(() => import('../pages/Catalog'));
const Connect = lazy(() => import('../pages/Connect'));
const SignupPage = lazy(() => import('../pages/Auth/Sighup'));
const ForgotPasswordPage = lazy(() => import('../pages/Auth/ForgotPassword'));
const ChangePasswordPage = lazy(() => import('../pages/Auth/ChangePassword'));
const OtpVerifyPage = lazy(() => import('../pages/Auth/OtpVerify'));

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem('sessionId');
    if (!token || token === 'undefined' || token === 'null') {
      return false;
    }
    return true;
  };

  return isAuthenticated() ? (
    <Layout>
      {children}
    </Layout>
  ) : (
    <Navigate to="/" replace />
  );
};


// Public Route Component
const PublicRoute = ({ children }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem('sessionId');
    return token !== null;
  };

  return isAuthenticated() ? <Navigate to="/app/chats" replace /> : children;
};


function AppRoutes() {
  return (
    <Suspense fallback={<SpinnerLoader />}>
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <SignupPage />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        }
      />
      <Route
        path="/verify"
        element={
          <PublicRoute>
            <OtpVerifyPage />
          </PublicRoute>
        }
      />

        {/* Protected Routes */}
        <Route
          path="/app/chats"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/contacts"
          element={
            <ProtectedRoute>
              <ContactsView />
            </ProtectedRoute>
          }
        />

        <Route
          path="/app/my-profile"
          element={
            <ProtectedRoute>
              <MyProfileContainer />
            </ProtectedRoute>
          }
        />

        <Route
          path="/app/settings"
          element={
            <ProtectedRoute>
              <SettingsContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/catalog/*"
          element={
            <ProtectedRoute>
              <CatalogContainer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/app/messages"
          element={
            <ProtectedRoute>
              <Connect />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
    </Suspense>
  );
}

export default AppRoutes;